/**
 * Created by JackCui on 2021/12/2
 */

export default function crumbsSchemaHandle ({title, apiName}) {
  return {
    _type: 'crumbs',
    viewComponentName: 'crumbs',
    props: {title},
    apiName
  }
}

export const crumbsProps = {
  // 面包屑数据  面包屑内的数据格式  name(页面名) url(跳转页面路径)
  crumbsData: {
    type: Array,
    default: () => []
  }
}
